<!-- @format -->

<template>
	<pc-collapse v-model="activeCol">
		<pc-collapse-item v-for="(item, idx) in baseConfigStore.FIELDS" :key="idx" :title="item.title" :name="item.title">
			<draggable
				:list="item.children"
				item-key="title"
				class="el-row fields-container"
				v-bind="{
					group: {
						name: item.children[0].category === 'container' ? 'container' : 'field',
						pull: canDrag ? 'clone' : false,
						put: false,
					},
					sort: false,
					ghostClass: 'ghost',
					animation: 300,
				}"
			>
				<template #item="{ element }">
					<el-col
						:span="12"
						:class="`fields-item fields-item-${element.pcProps.cols}`"
						:field-type="element.category === 'container' ? 'container' : 'field'"
					>
						<el-tooltip effect="dark" :content="element.pcProps.label" :show-after="500">
							<div class="fields-item-content">
								<el-icon>
									<component :is="`${element.icon}`" />
								</el-icon>
								<span>
									{{ element.pcProps.label }}
								</span>
							</div>
						</el-tooltip>
					</el-col>
				</template>
			</draggable>
		</pc-collapse-item>
	</pc-collapse>
</template>

<script setup lang="ts">
	import { useBaseConfigStoreWithOut } from '../../../config';
	import { draggable, PcCollapse, PcCollapseItem } from '@/components';

	interface Props {
		canDrag?: boolean;
	}

	withDefaults(defineProps<Props>(), {
		canDrag: true,
	});

	const name = inject<string>('name');

	const baseConfigStore = useBaseConfigStoreWithOut(name);

	const activeCol = ref<string[]>([]);

	onMounted(() => {
		setTimeout(() => {
			activeCol.value = baseConfigStore.FIELDS.map((i) => i.title);
		});
	});
</script>

<style scoped lang="scss">
	.fields-container {
		.fields-item {
			font-size: 12px;
			line-height: 30px;
			padding: 3px;

			.fields-item-content {
				padding: 1px;
				border: 1px solid var(--el-border-color-light);
				border-radius: 4px;
				cursor: move;
				background: #ffffff;
				display: flex;
				align-items: center;

				.el-icon {
					font-size: 15px;
					margin: 0 10px 0 5px;
				}
			}

			.fields-item-content:hover {
				color: var(--el-color-primary);
				border: 1px dashed var(--el-color-primary);
				border-radius: 4px;
			}

			.fields-item-content > span {
				// 字段过长省略
				display: inline-block;
				vertical-align: middle;
				text-overflow: ellipsis;
				overflow: hidden;
				white-space: nowrap;
				width: 100%;
			}
		}
	}
</style>
